import { render, staticRenderFns } from "./reset-password.view.vue?vue&type=template&id=4d933a3a&"
import script from "./reset-password.view.ts?vue&type=script&lang=js&"
export * from "./reset-password.view.ts?vue&type=script&lang=js&"
import style0 from "./reset-password.view.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports